import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import MultiTab from '@/components/MultiTab'
import Viser from 'viser-vue'
import VueCropper from 'vue-cropper'
import './utils/filter' // global filter

import TableTips from '@/components/TableTips'
import SearchForm from '@/components/SearchForm'

Vue.use(Viser)
Vue.use(Antd)
Vue.use(VueCropper)

Vue.config.productionTip = false

Vue.component('TableTips', TableTips)
Vue.component('SearchForm', SearchForm)

// 标签页功能初始化
MultiTab.install(Vue)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
